// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__dUVZD","arrowDown":"styles_arrowDown__3BEhw"};